var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0384 16.857C22.5899 14.58 23.9999 12 23.9999 12C23.9999 12 19.4999 3.75 11.9999 3.75C10.5593 3.75496 9.13502 4.05514 7.81494 4.632L8.96994 5.7885C9.94109 5.43473 10.9664 5.25252 11.9999 5.25C15.1799 5.25 17.8184 7.002 19.7519 8.9355C20.6825 9.87104 21.5167 10.8977 22.2419 12C22.1549 12.1305 22.0589 12.2745 21.9494 12.432C21.4469 13.152 20.7044 14.112 19.7519 15.0645C19.5044 15.312 19.2464 15.5565 18.9764 15.7935L20.0384 16.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9455 13.764C17.2803 12.8278 17.3423 11.8157 17.1243 10.8456C16.9063 9.87554 16.4174 8.98729 15.7143 8.28423C15.0113 7.58117 14.123 7.09221 13.1529 6.87424C12.1828 6.65628 11.1708 6.71827 10.2345 7.053L11.469 8.2875C12.0455 8.20499 12.6333 8.25786 13.1857 8.44194C13.7382 8.62602 14.2402 8.93624 14.652 9.34801C15.0638 9.75979 15.374 10.2618 15.5581 10.8143C15.7422 11.3668 15.7951 11.9545 15.7125 12.531L16.9455 13.764ZM12.531 15.7125L13.764 16.9455C12.8278 17.2802 11.8158 17.3422 10.8457 17.1243C9.87558 16.9063 8.98733 16.4173 8.28427 15.7143C7.58121 15.0112 7.09225 14.123 6.87429 13.1529C6.65632 12.1828 6.71831 11.1707 7.05304 10.2345L8.28754 11.469C8.20503 12.0455 8.25791 12.6332 8.44199 13.1857C8.62607 13.7382 8.93628 14.2402 9.34806 14.652C9.75984 15.0638 10.2619 15.374 10.8143 15.5581C11.3668 15.7421 11.9546 15.795 12.531 15.7125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.025 8.20499C4.755 8.44499 4.4955 8.68799 4.248 8.93549C3.31747 9.87103 2.48328 10.8977 1.758 12L2.0505 12.432C2.553 13.152 3.2955 14.112 4.248 15.0645C6.1815 16.998 8.8215 18.75 12 18.75C13.074 18.75 14.085 18.5505 15.03 18.21L16.185 19.368C14.8649 19.9448 13.4406 20.245 12 20.25C4.5 20.25 0 12 0 12C0 12 1.4085 9.41849 3.9615 7.14299L5.0235 8.20649L5.025 8.20499ZM20.469 21.531L2.469 3.53099L3.531 2.46899L21.531 20.469L20.469 21.531Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/HidePasswordIcon.fb696d2f690816bc4c583dd1ad905709.svg";
export { ForwardRef as ReactComponent };